import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { MenuItem } from '../../context-menus/components/menu-item';
import { useDrawerControls } from '../../drawers/components/drawer-context-provider';

export function ServiceRotationMenuItem({
    contextMenuItemView,
    clickParams,
}: {
    clickParams: EventContextMenuClickParams;
    contextMenuItemView: ContextMenuItemView;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    const handleSelect = (): void => {
        drawerControls.open({
            type: 'service-rotation',
            props: { eventId: clickParams.eventId },
        });
    };
    return <MenuItem contextMenuItemView={contextMenuItemView} onSelect={handleSelect} />;
}
